<!--影响采集的类型组件-->
<template>
  <div class="page-con">

    <!-- ==================皮肤镜图片操作及所见======================================== -->
    <div class="bottom-wrapper" v-acl="['diagnoses_image']" v-edit="['edit_PFJ']" v-show="sk" v-bind:style="skinBack">
      <!--影像区文字和图像-->
      <div class="head-con" v-loading="false"
           element-loading-text="正在上传"
           element-loading-spinner="el-icon-loading"
           element-loading-background="rgba(255, 255, 255, 0.2)">
        <div class="head-nav">
          <div class="text">影像区</div>
          <div class="btn-wrapper" v-if="sk">
            <img v-show="disableIntell" src="../assets/loading.png" class="loadingWait"/>
            <button class="btn iconfont refresh-images-btn" @click="refreshImages">&#xe654;
            </button>
            <button class="btn" style="margin-right: 10px" @click="remoteAccessImages('sk', 'sk1')">远程同步</button>
            <div class="uploadBtn" @mouseover="showRemoteSkinPanel" @mouseleave="hideRemoteSkinPanel">
              <!--<button class="btn" style="margin-right:10px;">远程获取</button>-->
              <div class="uploadType" v-show="showRemoteSkin" style="right: 30px">
                <div class="skinType" @click="remotePull('sk1')">
                  <div class="skinItem">
                    浸润皮肤镜
                  </div>
                </div>
                <div class="skinType" @click="remotePull('sk2')">
                  <div class="skinItem">
                    偏振光皮肤镜
                  </div>
                </div>
              </div>
            </div>
            
            <div v-if="hasAiAuth == 1">
           <!-- 暂时屏蔽以图搜图button-->
            <template v-if="disableIntell || btnEnabled">
              <button class="btn btnDisabled" style="margin-right:10px;">{{differentContent.buttonCon}}</button>
            </template>
            <template v-else>
              <button class="btn" @click="intelligentSearch" style="margin-right:10px;">{{differentContent.buttonCon}}</button>
            </template>
            </div>
            
            <button class="btn" @click="takeAPhone('sk')" style="margin-right:10px;">拍摄</button>
            <div class="upload-con">
              <div class="uploadBtn" @mouseover="showSkinPanel" @mouseleave="hideSkinPanel">
                <button class="btn">本地上传</button>
                <div class="uploadType" v-show="showSkin">
                  <div class="skinType" @click="uploadFile('sk1')">
                    <div class="skinItem">
                      浸润皮肤镜
                      <input ref='sk1' type="file" name="file" multiple="multiple"
                             class="upload_input" @change="upload($event,'jr')" style="cursor:pointer"
                             accept="image/jpeg, image/png, image/bmp"/>
                    </div>
                  </div>
                  <div class="skinType" @click="uploadFile('sk2')">
                    <div class="skinItem">
                      偏振光皮肤镜
                      <input ref='sk2' type="file" name="file" multiple="multiple"
                             class="upload_input" @change="upload($event,'pz')" style="cursor:pointer"
                             accept="image/jpeg, image/png, image/bmp"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class='img-con'>
          <template v-for="(item, index) in skinArr">
            <GeneralPlan
              :showLoadingIcon="item.showLoadingIcon"
              :isPrint="item.isPrint"
              :key="item.id"
              :arrayList='skinArr'
              :imgSrc="item.pathS"
              :imgSrcShow="item.path"
              :type="item.type"
              :id="item.id"
              :position="item.position_detail"
              @deleteReportImage="deleteReportImage(item.id)"
              v-on:addRepImg="dbclickAdd($event,item)" :index="index" v-on:opration="opration"
              @showThisPic="showThisPic"
              @intelligentSearch="intelligentSearch()"

            ></GeneralPlan>
          </template>
        </div>
      </div>
      <div class='report-con'>
        <!--<div class="left-row" @drop="drop" @dragover="allowDrop">
          <div class="text-header" id="fontM">报告图片：(双击或者拖动导入图片)</div>
          <div class="imgCon">
            <div class="img-box" v-for="(item, index) in skinReportImgs" :key="index"
                 @mouseenter="showRemove(index,true)" @mouseleave="showRemove(index,false)">
              <img :src="item.src" :key="index" v-bind:style="{width: item.width + 'px',height: item.height + 'px'}"
                   class="imgIt"/>
              <transition name="fade">
                <img v-show="item.showDelete" src="../assets/cancel.png" width="15%" class="deleIcon"
                     @click="deteImgFromReport(index)"/>
              </transition>
            </div>
          </div>
        </div>-->
        <div class="right-row skin">
          <div class="underMirrorStyle"
               @click="autoComplete($event, 'sk')"
          >
            <div class="title-box" @click="mirrorHeadClick('Skin')">
              <div class="title">镜下所见：</div>
              <div class="iconfont save-btn"
                   title="将镜下所见保存到自定义模板中"
                   @click.stop="saveTemplate($event, 'skin')">&#xe640;</div>
            </div>
            <textarea
              ref="mirrorSkin"
              style="outline: none;resize: none;"
              autocomplete="off"
              placeholder=""
              rows="5"
              v-model="skinUnderMirror"
            ></textarea>
          </div>
          <div v-show="skAuto" class="autoComplate">
            <ul style="max-height: 141px;overflow-y: auto;">
              <li class="item" v-for="(item, index) in skAutoList" :key="index"
                  @click="selectAutoTemplate(item.name, 'skin')">{{item.name}}
              </li>
            </ul>
          </div>
        </div>
        <div class="summary">
          <div class="sum-head" v-if="this.$store.state.controller.allowAiSearch == 1">
            <div id="fontM" style="width: 160px">智能辅助诊断结果摘要
              <!-- <p>智能辅助诊断结果摘要
                <el-popover
                      placement="right-end"
                      title="提示"
                      width="200"
                      trigger="hover"
                      content="该功能基于最新AI技术和标准皮肤镜影像库；结果仅供参考，不作为诊断依据"
                    >
                      <i slot="reference" class="iconfont icon-bangzhu popTips"></i>
                  </el-popover>
              </p> -->
            </div>
            <div class="btns" style="justify-content: flex-end">
              <button class="btn btn-btn" @click="detailResult" style="margin-right:5px;">详细结果</button>
              <button class="btn btn-btn" @click="importReport" style="margin-right:5px;">导入报告</button>
            </div>
          </div>
          <div class="img-list-con">
            <div class="img-list" v-if="isDialoges" style="">
              <div class="img-item" v-for="(item, index) in tempJsonArray" :key="index" @click="chooseSum($event,index)">
                <img :src="item.src" :class="{'isWidth':!item.isWidth,'isHeight':item.isWidth}"/>
                <template v-if="index === 0">
                  <el-radio-group v-model="model0" @change="chooseTheRadio($event,item,index)"
                                  style="display: flex;flex-direction:column;align-items:flex-start;margin-left:12px;color: #000"
                                  @mouseover.native="activeRadio(index,'model0Active')"
                                  @mouseleave.native="unactiveRadio(index,'model0Active')">
                    <el-radio
                      class="radio-label-text"
                      :name="`${item.id}`"
                      :disabled="model0Active"
                      :label="innerItem.cls_name"
                      v-for="(innerItem, innerIndex) in tempJsonArray[index].overviewRes"
                      :key="innerIndex"
                      style="margin-bottom: 10px;"
                      :title="innerItem.cls_name + ' ' + Number(innerItem.prob*100).toFixed(2) +'%'">{{innerItem.cls_name}}
                      <span>{{Number(innerItem.prob*100).toFixed(2) +'%'}}</span>
                    </el-radio>
                  </el-radio-group>
                </template>
                <template v-if="index === 1">
                  <el-radio-group v-model="model1" @change="chooseTheRadio($event,item,index)"
                                  style="display: flex;flex-direction:column;align-items:flex-start;margin-left:12px;color: #000"
                                  @mouseover.native="activeRadio(index,'model1Active')"
                                  @mouseleave.native="unactiveRadio(index,'model1Active')">
                    <el-radio
                      :name="`${item.id}`"
                      :disabled="model1Active"
                      :label="innerItem.cls_name"
                      v-for="(innerItem, innerIndex) in tempJsonArray[index].overviewRes"
                      :key="innerIndex"
                      :title="innerItem.cls_name + ' ' + Number(innerItem.prob*100).toFixed(2) +'%'"
                      style="margin-bottom: 10px;">{{innerItem.cls_name}}
                      <span >{{Number(innerItem.prob*100).toFixed(2) +'%'}}</span>
                    </el-radio>
                  </el-radio-group>
                </template>
                <template v-if="index === 2">
                  <el-radio-group v-model="model2" @change="chooseTheRadio($event,item,index)"
                                  style="display: flex;flex-direction:column;align-items:flex-start;margin-left:12px;color: #000"
                                  @mouseover.native="activeRadio(index,'model2Active')"
                                  @mouseleave.native="unactiveRadio(index,'model2Active')">
                    <el-radio :name="`${item.id}`" :disabled="model2Active" :label="innerItem.cls_name"
                              v-for="(innerItem, innerIndex) in tempJsonArray[index].overviewRes" :key="innerIndex"
                              style="margin-bottom: 10px;">{{innerItem.cls_name}}
                      <span >{{Number(innerItem.prob*100).toFixed(2) +'%'}}</span>
                    </el-radio>
                  </el-radio-group>
                </template>
              </div>
            </div>
    
          </div>
        </div>
      </div>
    </div>

    <!-- ==================大体图片操作及所见======================================== -->
    <div class="bottom-wrapper" v-acl="['diagnoses_image']" v-edit="['edit_DTT']" v-show="general" v-bind:style="generalBack">
      <!--影像区文字和图像-->
      <div class="head-con" v-loading="false"
           element-loading-text="正在上传"
           element-loading-spinner="el-icon-loading"
           element-loading-background="rgba(255, 255, 255, 0.2)">
        <div class="head-nav">
          <div class="text">影像区</div>
          <div class="btn-wrapper" v-show="general">
            <button class="btn iconfont refresh-images-btn" @click="refreshImages" >&#xe654;
            </button>
            <button class="btn" style="margin-right: 10px" @click="remoteAccessImages('dt', 'general')">远程同步</button>
            <button class="btn" @click="takeAPhone('dt')" style="margin-right:10px;">拍摄</button>
            <div class="upload-con">
              <button class="btn" @click="uploadFile('general')">本地上传</button>
              <input ref='general' type="file" name="file" multiple="multiple" class="upload_input"
                     @change="upload($event,'general')" accept="image/jpeg, image/png, image/bmp"/>
            </div>
          </div>
        </div>
        <div class='img-con'>
          <template v-for="(item, index) in generalArr">
            <GeneralPlan
              :showLoadingIcon="item.showLoadingIcon"
              :isPrint="item.isPrint"
              :key="index"
              :imgSrc="item.pathS"
              :imgSrcShow="item.path"
              :type="item.type"
              :id="item.id"
              :position="item.position_detail"
              :origin="item.origin"
              @deleteReportImage="deleteReportImage(item.id)"
              v-on:addRepImg="dbclickAdd($event,item)" :index="index" v-on:opration="opration"
              @showThisPic="showThisPic"
              @toggleWoodLamp="handleToggleWoodLamp"
            ></GeneralPlan>
          </template>
        </div>
      </div>
      <!--报告及图片所见2-4-3-->
      <div class='report-con'>
        <!--<div class="left-row" @drop="drop" @dragover="allowDrop">
          <div class="text-header">报告图片：(双击或者拖动导入图片)</div>
          <div class="imgCon">
            <div class="img-box" v-for="(item, index) in generalReportImgs" :key="index"
                 @mouseenter="showRemove(index,true)" @mouseleave="showRemove(index,false)">
              <img :src="item.src" :key="index" v-bind:style="{width: item.width + 'px',height: item.height + 'px'}"
                   class="imgIt"/>
              <transition name="fade">
                <img v-show="item.showDelete" src="../assets/cancel.png" width="15%" class="deleIcon"
                     @click="deteImgFromReport(index)"/>
              </transition>
            </div>
          </div>
        </div>-->
        <div class="right-row">
          <div class="underMirrorStyle">
            <div class="title-box" @click="mirrorHeadClick('General')">
              <div class="title">影像所见：</div>
              <div class=""></div>
            </div>
            <textarea
              ref="mirrorGeneral"
              style="outline: none;resize: none;"
              autocomplete="off"
              rows="5"
              placeholder=""
              v-model="generalUnderMirror"
            ></textarea>
          </div>
        </div>
      </div>
    </div>

    <!-- ==================CT 图片操作及所见======================================== -->
    <div class="bottom-wrapper" v-acl="['diagnoses_image']" v-edit="['edit_CT']" v-show="ct" v-bind:style="ctBack">
      <!--影像区文字和图像-->
      <div class="head-con" v-loading="false"
           element-loading-text="正在上传"
           element-loading-spinner="el-icon-loading"
           element-loading-background="rgba(255, 255, 255, 0.2)">
        <div class="head-nav">
          <div class="text">影像区</div>
          <div class="btn-wrapper" v-if="ct">
            <button class="btn iconfont refresh-images-btn" @click="refreshImages" >&#xe654;
            </button>
            <button class="btn" style="margin-right: 10px" @click="remoteAccessImages('CT', 'ct')">远程同步</button>
            <!--<button class="btn" @click="openRemoteDialog('ct')" style="margin-right:10px;">远程获取</button>-->
            <div class="upload-con">
              <button class="btn" @click="uploadFile('ct')">本地上传</button>
              <input ref='ct' type="file" name="file" multiple="multiple" class="upload_input"
                     @change="upload($event,'ct')" accept="image/jpeg, image/png, image/bmp"/>
            </div>
          </div>
        </div>
        <div class='img-con'>
          <template v-for="(item, index) in ctArr">
            <GeneralPlan
              :showLoadingIcon="item.showLoadingIcon"
              :isPrint="item.isPrint"
              :key="index"
              :imgSrc="item.pathS"
              :imgSrcShow="item.path"
              :type="item.type"
              :id="item.id"
              :position="item.position_detail"
              :origin="item.origin"
              @deleteReportImage="deleteReportImage(item.id)"
              v-on:addRepImg="dbclickAdd($event,item)" :index="index" v-on:opration="opration"
              @showThisPic="showThisPic"
              @toggleWoodLamp="handleToggleWoodLamp"
            ></GeneralPlan>
          </template>
        </div>
      </div>
      <!--报告及CT 所见-->
      <div class='report-con'>
        <!--<div class="left-row" @drop="drop" @dragover="allowDrop">
          <div class="text-header">报告图片：(双击或者拖动导入图片)</div>
          <div class="imgCon">
            <div class="img-box" v-for="(item, index) in ctReportImgs" :key="index" @mouseenter="showRemove(index,true)"
                 @mouseleave="showRemove(index,false)">
              <img :src="item.src" :key="index" v-bind:style="{width: item.width + 'px',height: item.height + 'px'}"
                   class="imgIt"/>
              <transition name="fade">
                <img v-show="item.showDelete" src="../assets/cancel.png" width="15%" class="deleIcon"
                     @click="deteImgFromReport(index)"/>
              </transition>
            </div>
          </div>
        </div>-->
        <div class="right-row">
          <div class="underMirrorStyle"
               @click="autoComplete($event, 'ct')"
          >
            <div class="title-box" @click="mirrorHeadClick('Ct')">
              <div class="title">CT影像所见：</div>
              <div class="iconfont save-btn"
                   title="将影像所见保存到自定义模板中" @click="saveTemplate($event, 'ct')">&#xe640;</div>
            </div>
            <textarea
              ref="mirrorCt"
              style="outline: none;resize: none;"
              autocomplete="off"
              rows="5"
              placeholder=""
              v-model="ctUnderMirror"
            ></textarea>
          </div>
          <div v-show="ctAuto" class="autoComplate">
            <ul style="max-height: 141px;overflow-y: auto;">
              <li class="item" v-for="(item, index) in ctAutoList" :key="index"
                  @click="selectAutoTemplate(item.name, 'ct')">{{item
                .name}}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    
    <!-- ==================超声图片操作及所见======================================== -->
    <div class="bottom-wrapper" v-acl="['diagnoses_image']" v-edit="['edit_BC']" v-show="bc" v-bind:style="bcBack">
      <!--影像区文字和图像-->
      <div class="head-con" v-loading="false"
           element-loading-text="正在上传"
           element-loading-spinner="el-icon-loading"
           element-loading-background="rgba(255, 255, 255, 0.2)">
        <div class="head-nav">
          <div class="text" id="fontM">影像区</div>
          <div class="btn-wrapper" v-show="bc">
            <button class="btn iconfont refresh-images-btn" @click="refreshImages" >&#xe654;
            </button>
            <button class="btn" style="margin-right: 10px" @click="remoteAccessImages('B_ultrasonic', 'bc')">远程同步</button>
            <!--<button class="btn" @click="remotePull('bc')" style="margin-right: 10px;">远程获取</button>-->
            <div class="upload-con">
              <button class="btn" @click="uploadFile('bc')">本地上传</button>
              <input ref='bc' type="file" name="file" multiple="multiple" class="upload_input"
                     @change="upload($event,'bc')" accept="image/jpeg, image/png, image/bmp"/>
            </div>
          </div>
        </div>
        <div class='img-con'>
          <template v-for="(item, index) in bcArr">
            <GeneralPlan
              :showLoadingIcon="item.showLoadingIcon"
              :isPrint="item.isPrint"
              :key="index"
              :type="item.type"
              :imgSrc="item.pathS"
              :imgSrcShow="item.path"
              :id="item.id"
              :position="item.position_detail"
              @deleteReportImage="deleteReportImage(item.id)"
              v-on:addRepImg="dbclickAdd($event,item)" :index="index" v-on:opration="opration"
              @showThisPic="showThisPic"
            ></GeneralPlan>
          </template>
        </div>
      </div>
      <!--报告及超声所见-->
      <div class='report-con'>
        <!--<div class="left-row" @drop="drop" @dragover="allowDrop">
          <div class="text-header">报告图片：(双击或者拖动导入图片)</div>
          <div class="imgCon">
            <div class="img-box" v-for="(item, index) in bcReportImgs" :key="index" @mouseenter="showRemove(index,true)"
                 @mouseleave="showRemove(index,false)">
              <img :src="item.src" :key="index" v-bind:style="{width: item.width + 'px',height: item.height + 'px'}"
                   class="imgIt"/>
              <transition name="fade">
                <img v-show="item.showDelete" src="../assets/cancel.png" width="15%" class="deleIcon"
                     @click="deteImgFromReport(index)"/>
              </transition>
            </div>
          </div>
        </div>-->
        <div class="right-row">
          <div class="underMirrorStyle"
               @click="autoComplete($event, 'bc')"
          >
            <div class="title-box" @click="mirrorHeadClick('Bc')">

              <div class="title">超声所见：</div>
              <div class="iconfont save-btn"
                   title="将超声所见保存到自定义模板中" @click="saveTemplate($event, 'bc')">&#xe640;</div>
            </div>
            <textarea
              ref="mirrorBc"
              style="outline: none;resize: none;"
              autocomplete="off"
              rows="5"
              placeholder=""
              v-model="bcUnderMirror"
            ></textarea>
          </div>
          <div v-show="bcAuto" class="autoComplate">
            <ul style="max-height: 141px;overflow-y: auto;">
              <li class="item" v-for="(item, index) in bcAutoList" :key="index"
                  @click="selectAutoTemplate(item.name, 'bc')">{{item
                .name}}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- ==================病理图片操作及所见======================================== -->
    <div class="bottom-wrapper" v-acl="['diagnoses_image']" v-edit="['edit_BL']" v-show="bingli" v-bind:style="blBack">
      <!--影像区文字和图像-->
      <div class="head-con" v-loading="false"
           element-loading-text="正在上传"
           element-loading-spinner="el-icon-loading"
           element-loading-background="rgba(255, 255, 255, 0.2)">
        <div class="head-nav">
          <div class="text">影像区</div>
          <div class="btn-wrapper" v-show="bingli">
            <button class="btn iconfont refresh-images-btn" @click="refreshImages" >&#xe654;
            </button>
            <button class="btn" style="margin-right: 10px" @click="remoteAccessImages('pathology', 'bingli')">远程同步</button>
            <!--<button class="btn" @click="remotePull('bingli')" style="margin-right:10px;">远程获取</button>-->
            <div class="upload-con">
              <button class="btn" @click="uploadFile('bingliInput')">本地上传</button>
              <input ref='bingliInput' type="file" name="file" multiple="multiple" class="upload_input"
                     @change="upload($event,'bl')" accept="image/jpeg, image/png, image/bmp"/>
            </div>
          </div>
        </div>
        <div class='img-con'>
          <template v-for="(item, index) in blArr">
            <GeneralPlan
              :showLoadingIcon="item.showLoadingIcon"
              :isPrint="item.isPrint"
              :key="index"
              :imgSrc="item.pathS"
              :imgSrcShow="item.path"
              :type="item.type"
              :id="item.id"
              :position="item.position_detail"
              :origin="item.origin"
              @deleteReportImage="deleteReportImage(item.id)"
              v-on:addRepImg="dbclickAdd($event,item)" :index="index" v-on:opration="opration"
              @showThisPic="showThisPic"
              @toggleWoodLamp="handleToggleWoodLamp"
            ></GeneralPlan>
          </template>
        </div>
      </div>
      <!--报告及镜下所见-->
      <div class='report-con'>
        <!--<div class="left-row" @drop="drop" @dragover="allowDrop">
          <div class="text-header">报告图片：(双击或者拖动导入图片)</div>
          <div class="imgCon">
            <div class="img-box" v-for="(item, index) in blReportImgs" :key="index" @mouseenter="showRemove(index,true)"
                 @mouseleave="showRemove(index,false)">
              <img :src="item.src" :key="index" v-bind:style="{width: item.width + 'px',height: item.height + 'px'}"
                   class="imgIt"/>
              <transition name="fade">
                <img v-show="item.showDelete" src="../assets/cancel.png" width="15%" class="deleIcon"
                     @click="deteImgFromReport(index)"/>
              </transition>
            </div>
          </div>
        </div>-->
        <div class="right-row">
          <div class="underMirrorStyle"
               @click="autoComplete($event, 'bl')"
          >
            <div class="title-box" @click="mirrorHeadClick('Bl')">
              <div class="title">镜下所见：</div>
              <div class="iconfont save-btn"
                   title="将镜下所见保存到自定义模板中" @click="saveTemplate($event, 'bl')">&#xe640;</div>
            </div>
            <textarea
              ref="mirrorBl"
              style="outline: none;resize: none;"
              autocomplete="off"
              rows="5"
              placeholder=""
              v-model="blUnderMirror"
            ></textarea>
          </div>
          <div v-show="blAuto" class="autoComplate">
            <ul style="max-height: 141px;overflow-y: auto;">
              <li class="item" v-for="(item, index) in blAutoList" :key="index"
                  @click="selectAutoTemplate(item.name, 'bl')">{{item
                .name}}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal='false'
      class="remoteWrapper"
      title="选择图片"
      :visible.sync="dialogVisible"
      width="1270px">
      <el-container style="width: 1230px;height: 500px;border: 1px solid #000">
        <el-aside :width="asideWidth + 'px'" style="height: 100%;"
                  @click.native="backToRoot">
          <el-tree :data="folderData"
                   :props="defaultProps"
                   @node-expand="handleNodeClick"
                   @node-click="handleNodeClick"
                   style="background-color: inherit"
                   :highlight-current="highlightCurrent"
                   class="my-el-tree"
                   empty-text=""
          >
            <span class="span-ellipsis" slot-scope="{ node }">
                <span :title="node.label">{{ node.label }}</span>
            </span>
          </el-tree>
        </el-aside>
        <div class="line-resize" @mouseenter="lineResizeEnter" @mouseleave="lineResizeLeave"
             @mousedown="lineResizeDown"></div>
        <el-container>
          <el-main class="main-wrapper">
            <div class="main-wrapper-box">
              <div class="head">
                <div class="allSelect">
                  <div>全选</div>
                  <div class="no-select iconfont" v-show="!allSelect"
                       @click="handleAllSelect(true)">&#xe625;
                  </div>
                  <div class="selected iconfont" v-show="allSelect" @click="handleAllSelect(false)">&#xe627;
                  </div>
                </div>
              </div>
              <div class="imageItem" v-for="(item, index) in remoteImages" :key="item.id" @click="imageSelect(index)">
                <div class="pic" style="">
                  <img style="width: 100%;height: 100%" v-lazy="{src:item.url, error: item.url}" alt="" src=""
                       @load="imageOnload"
                       @mousedown.prevent=""
                       @error="imgError($event, item.url)"
                       >
                </div>
                <div class="name">{{item.name}}</div>
                <div class="isSelect iconfont" :class="{select: item.isSelect}">&#xe642;</div>
              </div>
              <div class="empty" v-show="remoteImages.length === 0" style="user-select: none;">文件夹中没有图片</div>
            </div>
          </el-main>
        </el-container>
      </el-container>
      <span slot="footer" class="dialog-footer">
                <el-button @click="closeDialog">取 消</el-button>
                <el-button type="primary" @click="remoteAccess">获 取</el-button>
          </span>
    </el-dialog>
  </div>
</template>
<script>
  import GeneralPlan from './GeneralPicture.vue';
  import Path from 'path';
  import axios from 'axios';
  import api from '../api.ts';
  import csrfToken from '../getToken';
  import Utils from '../utils/utils.js';
  import gql from 'graphql-tag';
  import Jimp from 'jimp';
  import addDiagnosisGql from '../gql/addDiagnosis.gql';
  import {mapGetters} from 'vuex';
  import _ from 'lodash';
  import crypto from 'crypto';
  import {checkImage} from '../utils/imageAuto.js';
  import knowledgeDicTemplate from "../utils/knowledgeDicTemplate.js";
  import moment from 'moment';

  const differentContent = {};
  if (process.env.VUE_APP_SHOW_INTEL === 'yes') {
    // differentContent.buttonCon = '智能搜图';
    // differentContent.fontMCon = '智能辅助诊断结果摘要';
    // differentContent.isShowSimilarity = true;
    differentContent.buttonCon = '以图搜图';
    differentContent.fontMCon = '搜图结果(TOP2相似度)';
    differentContent.isShowSimilarity = false;
  } else {
    differentContent.buttonCon = '以图搜图';
    differentContent.fontMCon = '搜图结果(TOP2相似度)';
    differentContent.isShowSimilarity = false;
  }

  export default {
    mixins: [knowledgeDicTemplate],
    
    props: {
      diseaseid: String,
      template: Object,
      diagnoseType: String,
      general: Boolean,
      ct: Boolean,
      bc: Boolean,
      sk: Boolean,
      bingli: Boolean,
      ImgArr: Array,
      diagnosis_id: Number,
      // 预览结果
      overviewResult: Array,
      // 疾病百科
      wordBook: Object,
      // 按钮是否允许点击
      btnEnabled: Boolean,
      position: Object,
      isNewDiagnose: Boolean,
      disableIntell: Boolean,
      // 编辑时传入的镜下所见数据
      reportText: Object,
      diagnoseResult: String,
    },
    data() {
      return {
        differentContent,
        abc: 0,
        hasAiAuth:1,
        skAuto: false,
        skAutoList: [],
        ctAuto: false,
        ctAutoList: [],
        bcAuto: false,
        bcAutoList: [],
        blAuto: false,
        blAutoList: [],
        // // 皮肤镜诊断预览结果
        // tempJsonArr: [],
        // 相关样式类的添加
        generalBack: {
          backgroundColor: '#eff3f7',
        },
        ctBack: {
          backgroundColor: '#eff3f7',
        },
        blBack: {
          backgroundColor: '#eff3f7',
        },
        skinBack: {
          backgroundColor: '#eff3f7',
        },
        bcBack: {
          backgroundColor: '#eff3f7',
        },
        reportImgs: [],
        generalArr: [],
        ctArr: [],
        skinArr: [],
        bcArr: [],
        blArr: [],
        overviewRadio: '',
        isDialoges: false,
        // 皮肤镜报告图片数组
        skinReportImgs: [],
        skinUnderMirror: "",
        // 大体图图报告图片数组
        generalReportImgs: [],
        generalUnderMirror: "",
        // ct报告图片数组
        ctReportImgs: [],
        ctUnderMirror: "",
        // Bc报告图片数组,
        bcReportImgs: [],
        bcUnderMirror: "",
        // 病理报告图片数组
        blReportImgs: [],
        blUnderMirror: "",
        // 镜下所见
        underMirror: "",
        // choosed disease name order to search the image
        choosedResultIndex: 0,
        // 显示皮肤镜类型
        showSkin: false,
        showRemoteSkin: false,
        // 选择的皮肤镜类型
        skinType: -1,
        // 预览结果图片数组
        reviewImgArr: [],
        // 恶性概率值最高的是哪个索引
        topIndex: -1,
        model0: "",
        model1: "",
        model2: "",
        model0Active: false,
        model1Active: true,
        model2Active: true,
        tempJsonArray: [],
        loadingType: {
          general: {
            typeIndex: 1,
            isClick: false,
          },
          ct: {
            typeIndex: 8,
            isClick: false,
          },
          bc: {
            typeIndex: 16,
            isClick: false,
          },
          bingli: {
            typeIndex: 32,
            isClick: false,
          },
          sk1: {
            typeIndex: 2,
            isClick: false,
          },
          sk2: {
            typeIndex: 4,
            isClick: false,
          },
        },
        generalLoading: false,
        ctLoading: false,
        bcLoading: false,
        bingliLoading: false,
        skLoading: false,
        // 远程获取地址
        requestUrl: '',
        // dialog参数
        dialogVisible: false,
        // dialog树状数据
        folderData: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        // 远程获取图片展示数据
        remoteImages: [],
        remoteImagesBackups: [],
        url: '',
        secretPath: '',
        typeIndex: '',
        allSelect: false,
        highlightCurrent: true,
        imageId: 0,
        lineResizeToggle: false,
        lineEnter: false,
        lineResizeClientX: 0,
        asideWidth: 250,
        initialAsideWidth: 250,
        // 远程同步要上传的图片
        remoteSyncImagesArr: [],
      }
    },
    // 监听大体图，ct图，bc图的相关属性值得变化
    watch: {
      // 'generalArr':()=>{
      
      //  },
      // 'ctArr':()=>{
     
      // },
      // 'bcArr':()=>{
     
      // },
      // 'skinArr':()=>{
      
      // },
      // 'blArr':()=>{
   
      // },
      
      
  /*    'general':function(){
        if (this.general){
          this.generalArr = this.detectImgArr(Utils.GENERAL.code);
        }
      },
      'ct':function(){
        if (this.ct){
          this.ctArr = this.detectImgArr(Utils.CT.code);
        }
      },
      'bc':function(){
        if (this.bc){
          this.bcArr = this.detectImgArr(Utils.BC.code);
        }
    
      },
      'sk':function(){
        if (this.sk){
          this.skinArr = this.detectSkinArr();
        }
      },
      'bingli':function(){
        if (this.bingli){
          this.blArr = this.detectImgArr(Utils.PATHOlOGY.code)
        }
      },*/
      reportText(newVal) {
        this.blUnderMirror = newVal.pathology_report_text;
        this.bcUnderMirror = newVal.b_ultrasonic_report_text;
        this.ctUnderMirror = newVal.ct_report_text;
        this.generalUnderMirror = newVal.macro_report_text;
        this.skinUnderMirror = newVal.dermoscopy_report_text;
      },
      skinUnderMirror: {
        handler(newval, oldval) {
          this.skinUnderMirror = newval;
          this.$store.commit("handleUnderMirror", {type: "skin", data: this.skinUnderMirror});
          this.modifyDiagnose(10);
        }
      },
      generalUnderMirror: {
        handler(newval, oldval) {
          this.generalUnderMirror = newval;
          this.$store.commit("handleUnderMirror", {type: "general", data: this.generalUnderMirror});
          this.modifyDiagnose(Utils.GENERAL.code);
        }
      },
      ctUnderMirror: {
        handler(newval, oldval) {
          this.ctUnderMirror = newval;
          this.$store.commit("handleUnderMirror", {type: "ct", data: this.ctUnderMirror});
          this.modifyDiagnose(Utils.CT.code);
        }
      },
      bcUnderMirror: {
        handler(newval, oldval) {
          this.bcUnderMirror = newval;
          this.$store.commit("handleUnderMirror", {type: "bc", data: this.bcUnderMirror});
          this.modifyDiagnose(Utils.BC.code);
        }
      },
      blUnderMirror: {
        handler(newval, oldval) {
          this.blUnderMirror = newval;
          this.$store.commit("handleUnderMirror", {type: "bl", data: this.blUnderMirror});
          this.modifyDiagnose(Utils.PATHOlOGY.code);
        }
      },
      disableIntell: {
        handler(newval, oldval) {
          this.disableIntell = newval;
        }
      },
      ImgArr: {
        async handler(newval, oldval) {
         
          this.ImgArr = newval;
        /*  for (let i = 0; i < this.ImgArr.length; i++) {
            this.ImgArr[i].isWidth = await checkImage(this.ImgArr[i].path);
          }*/

          this.blArr = [];
          this.generalArr = [];
          this.skinArr = [];
          this.ctArr = [];
          this.bcArr = [];
          /*  if(this.general){
              this.generalArr = this.detectImgArr(Utils.GENERAL.code);
            }else if (this.ct){
              this.ctArr = this.detectImgArr(Utils.CT.code);
            } else if (this.bc){
              this.bcArr = this.detectImgArr(Utils.BC.code);
            }else if (this.sk){
              this.skinArr = this.detectSkinArr();
            }else if (this.bingli){
              this.blArr = this.detectImgArr(Utils.PATHOlOGY.code);
            }*/
  
          this.generalArr = this.detectImgArr(Utils.GENERAL.code);
          console.log("IN CollectionType.vue, generalArr:", this.generalArr);
          this.ctArr = this.detectImgArr(Utils.CT.code);
          this.bcArr = this.detectImgArr(Utils.BC.code);
          this.skinArr = this.detectSkinArr();
          this.blArr = this.detectImgArr(Utils.PATHOlOGY.code);
        }
      },
      overviewResult: {
        async handler(newval, oldval) {
          if (newval.length !== 0) {
            this.overviewResult = newval;
            let topIndexArr = [];
            if (this.reviewImgArr.length > 0 && this.overviewResult.length > 0) {
              for (let j = 0, len = this.reviewImgArr.length; j < len; j++) {
                if (!!this.overviewResult[j]) {
                  topIndexArr.push({prob: this.overviewResult[j].malignant_prob, index: j});
                }
       
                let srcJson = {};
                srcJson.src = this.reviewImgArr[j].src;
                srcJson.id = this.reviewImgArr[j].id;
                srcJson.overviewRes = [];
                if (this.overviewResult[j].result) {

                  for (let s=0;s<this.overviewResult[j].result.length;s++) {
                    srcJson.overviewRes.push(this.overviewResult[j].result[s]);

                  }
                }
                // srcJson.overviewRes.push(this.overviewResult[j].result[0]);
                // srcJson.overviewRes.push(this.overviewResult[j].result[1]);
                srcJson.overviewRes =_.sortBy(srcJson.overviewRes, (item) => {
                  return -item.prob;
                });
                srcJson.overviewRes =  srcJson.overviewRes.slice(0,2)
                srcJson.modelData = "";
                srcJson.isWidth = await checkImage(srcJson.src);
                this.tempJsonArray.push(srcJson);
              }
              // 对数组进行去重
              this.tempJsonArray = Utils.uniqObjInArray(this.tempJsonArray);
              if (this.tempJsonArray.length !== 0 && this.overviewResult.length !== 0) {
                // 显示智能诊断预览结果
                this.model0 = this.tempJsonArray[0].overviewRes[0].cls_name;// 默认赋值第一个radio
                this.chooseTheRadio(this.tempJsonArray[0].overviewRes[0].cls_name, '', 0)
                this.isDialoges = true;
              }
            }
            topIndexArr.sort((a, b) => {
              if (a.prob < b.prob) {
                return -1;
              } else if (a.prob === b.prob) {
                return 0;
              } else {
                return 1;
              }
            })
            if (topIndexArr.length > 0) {
              this.topIndex = topIndexArr[0].index;
            }
          }
        },
        immediate: true,
        deep: true
      },
      isNewDiagnose: {
        handler(newval, oldval) {
          this.isNewDiagnose = newval;
          if (this.isNewDiagnose) {
            // 开启新的诊断
            this.reportImgs = [];
            this.underMirror = "";
            this.tempJsonArray = [];
            // 清除诊断相关信息
            this.reviewImgArr = [];
            this.skinReportImgs = [];
            this.skinUnderMirror = "";
            this.generalReportImgs = [];
            this.generalUnderMirror = "";
            this.bcReportImgs = [];
            this.bcUnderMirror = "";
            this.ctReportImgs = [];
            this.ctUnderMirror = "";
            this.blReportImgs = [];
            this.blUnderMirror = "";
          }
        }
      },
      getSkinUnderMirror: {
        handler(newval, oldval) {
          this.skinUnderMirror = newval;
        }
      },
      getGeneralUnderMirror: {
        handler(newval, oldval) {
          this.generalUnderMirror = newval;
        }
      },
      getCTUnderMirror: {
        handler(newval, oldval) {
          this.ctUnderMirror = newval;
        }
      },
      getBCUnderMirror: {
        handler(newval, oldval) {
          this.bcUnderMirror = newval;
        }
      },
      getBlUnderMirror: {
        handler(newval, oldval) {
          this.blUnderMirror = newval;
        }
      },
      remoteImages: {
        handler(newVal) {
          const arr = newVal.filter(item => {
            return item.isSelect === true;
          });
          if (arr.length !== 0 && arr.length === newVal.length) {
            this.allSelect = true;
          } else {
            this.allSelect = false;
          }
        },
        deep: true,
      },
      SK() {
        alert("发生变化")
      }
    },
    // 计算属性
    computed: {
      ...mapGetters(['getSkinUnderMirror', 'getGeneralUnderMirror', 'getCTUnderMirror', 'getBCUnderMirror', 'getBlUnderMirror'])
    },
    created() {
      this.hasAiAuth = this.$store.state.controller.allowAiSearch
      let choosedImgArr = this.$store.state.chooseItImgArr;
      document.addEventListener('click', () => {
        this.skAuto = false;
        this.ctAuto = false;
        this.bcAuto = false;
        this.blAuto = false;
      });
    },
    components: {
      GeneralPlan
    },
    mounted() {
      document.onmouseup = () => {
        this.lineResizeToggle = false
        this.initialAsideWidth = this.asideWidth
        this.lineEnter = false
      };
      // document.onmousedown = (e) => {
      //   this.lineResizeToggle = true
      //   this.lineResizeClientX = e.clientX
      //   console.log('this.lineResizeToggle', this.lineResizeToggle);
      // };
      document.onmousemove = (e) => {
        if (this.lineResizeToggle && this.lineEnter) {
          const num = this.lineResizeClientX
          let count;
          if ((e.clientX - num) >= 0) {
            count = Math.min(this.initialAsideWidth + (e.clientX - num) , 800);
          } else {
            count = Math.max(this.initialAsideWidth + (e.clientX - num) , 100);
          }
          
          this.asideWidth = count
        }
      };
    },
    methods: {
      showThisPic(path) {
        this.$emit('showThisPic', path);
      },
      mirrorHeadClick(val) {
        this.$refs['mirror' + val].focus();
      },
      // 要删除添加到打印报告图片列表中的图片，先找到打印报告图片列表的中的图片的index
      handleToggleWoodLamp({ id, origin }) {
        // 更新 generalArr 中对应 item 的 origin
        const item = this.generalArr.find(i => i.id === id);
        if (item) {
          this.$set(item, 'origin', origin);
        }
        // 同步更新 ImgArr 中的 origin
        const srcItem = this.ImgArr.find(i => i.id === id);
        if (srcItem) {
          this.$set(srcItem, 'origin', origin);
        }
      },
      deleteReportImage(id) {
        if (this.general) {
          if (this.generalReportImgs.length) {
            const findIndex = this.generalReportImgs.findIndex(item => item.id === id);
            if (findIndex > -1) {
              // 执行删除操作
              this.deteImgFromReport(findIndex);
            }
          }
        } else if (this.ct) {
          // this.ctReportImgs
          if (this.ctReportImgs.length) {
            const findIndex = this.ctReportImgs.findIndex(item => item.id === id);
            if (findIndex > -1) {
              // 执行删除操作
              this.deteImgFromReport(findIndex);
            }
          }
        } else if (this.bc) {
          // this.bcReportImgs
          if (this.bcReportImgs.length) {
            const findIndex = this.bcReportImgs.findIndex(item => item.id === id);
            if (findIndex > -1) {
              // 执行删除操作
              this.deteImgFromReport(findIndex);
            }
          }
        } else if (this.sk) {
          // this.skinReportImgs
          if (this.skinReportImgs.length) {
            const findIndex = this.skinReportImgs.findIndex(item => item.id === id);
            if (findIndex > -1) {
              // 执行删除操作
              this.deteImgFromReport(findIndex);
            }
          }
        } else if (this.bingli) {
          // this.blReportImgs;
          if (this.blReportImgs.length) {
            const findIndex = this.blReportImgs.findIndex(item => item.id === id);
            if (findIndex > -1) {
              // 执行删除操作
              this.deteImgFromReport(findIndex);
            }
          }
        }
      },
      // 取到远程同步要上传的图片
      async handleRemoteSyncImages(data, url, folderPath) {
       
        if (data.images.length) {
          for (const imageItem of data.images) {
            imageItem.name = decodeURIComponent(imageItem.file);
            imageItem.url = `${this.url}${folderPath}${imageItem.file}${this.secretPath}`;
            this.remoteSyncImagesArr.push(imageItem);
          }
        }
        if (data.folders.length) {
          for (const folderName of data.folders) {
            const response = await axios.request({
              method: 'get',
              url: `${url}${folderName}`
            });
            const folderUrl = folderPath !== '/' ? `${folderPath}` : '/';
            await this.handleRemoteSyncImages(response.data, `${url}${folderName}/`,`${folderUrl}${folderName}/`)
          }
        }
      },
      
      // 远程同步
      async remoteAccessImages(type, val) {        
        if (window.localStorage.getItem('system_set')) {
          const system_set = JSON.parse(window.localStorage.getItem('system_set'));
          if (system_set[type].ip && system_set[type].port && system_set[type].agentName) {
            let agentName = system_set[type].agentName;
            if (this.diagnosis_id === -1) {
              this.$message.error("请先添加检查部位!!!");
              return;
            }
            /*if (val === 'sk1' || val === 'sk2') {
              this.skLoading = true;
            } else {
              this[val + 'Loading'] = true;
            }*/

            try {
              // 获取http地址
              const url = `https://${system_set[type].ip}:${system_set[type].port}`;
              // 请求key并算出secret
              //const msgKey = await axios.get(url + '/key');
              // 设置 withCredentials: false， 否则会报跨域问题
              //console.log("In remoteAccessImages, before axios.request.");
              const msgKey = await axios.request({
                method: 'get',
                url: url + '/key',
                // added by zdh to unblock CROS
                withCredentials: false,
              });

              const secret = crypto.createHash('sha1').update(msgKey.data.key.split('').reverse().join('')).digest('hex');
              /*// 获取保存在本地的lastsynctime
              let time = '';
              if (window.localStorage.getItem(`lastsynctime_${type}`)) {
                time = JSON.parse(window.localStorage.getItem(`lastsynctime_${type}`));
              }*/
              const getAgentSyncTimeRes = await this.$apollo.query({
                query: gql`{
										getAgentSyncTime(agent_name:"${agentName}")
								}`,
                fetchPolicy: "no-cache"
              });
            
              let agentSyncRes = getAgentSyncTimeRes.data.getAgentSyncTime          
              this.requestUrl = url + '/list?secret=' + secret + '&lastsynctime=' + agentSyncRes;
              this.url = url;
              this.secretPath = `?secret=${secret}`;
              // 请求list获取图片地址列表； 设置 withCredentials: false， 否则会报跨域问题。
              const msgList = await axios.request({
                method: 'get',
                url: this.requestUrl,
                // added by zdh to unblock CROS
                withCredentials: false 
              });
              // 上传前清空列表
              this.remoteSyncImagesArr = [];              
              if (msgList.data.agentname !== agentName) {
                this.$message.error('agentName不匹配！');
                return
              }              
              await this.handleRemoteSyncImages(msgList.data, `${this.requestUrl}&path=`, '/');
              if (this.remoteSyncImagesArr.length === 0) {
                this.$message.error('没有找到可上传的图片');
                /*if (val === 'sk1' || val === 'sk2') {
                  this.skLoading = false;
                } else {
                  this[val + 'Loading'] = false;
                }*/
                return
              }      
              
              const newImagesArrAll = _.chunk(this.remoteSyncImagesArr, 1); 
              if (newImagesArrAll && newImagesArrAll.length === 0){
                return
              }
              let syncLastTime = newImagesArrAll[newImagesArrAll.length-1][0].imgtime
            
              let count = 0;
              for (const imagesArr of newImagesArrAll) {
                // 上传前处理
                let imgArr = [];
                for (let i = 0; i < imagesArr.length; i++) {
                  const item = imagesArr[i];
                  const ext1 = item.file.match(/jpg$|jpeg$|png$/);
                  let ext = ext1 ? ext1[0] : 'jpg';
                  let b64 = await this.dealBmpImage1(item.url);
                  if (!b64) {
                    b64 = await this.dealBmpImage1(item.url);
                  }
                  const obj = {
                    type: this.loadingType[val].typeIndex,
                    position_overview: this.position.overviewPosition,
                    position_detail: this.position.overviewPosition + '-' +this.position.detailPosition,
                    base64: b64.replace(/^data:image\/(jpeg|png);base64,/, ""),
                    ext,
                    origin: imagesArr[i].origin,
                    upload_mark: new Date().valueOf() + '_' + Math.floor(Math.random() * 1000),
                  };
                  imgArr.push(obj);
                }
                // 上传
                /*const t = moment().valueOf();*/
                // 显示正在上传缩略图
                this.handleShowThumbnailImage(imgArr);
                const response = await this.$apollo.mutate({
                  mutation: gql`mutation (
                    $diagnosis_id: Int!
                    $images: [ImageInput!]!
                    $last_img_time: String
                    $agent_name: String
                  ){
                    addImages(
                      diagnosis_id: $diagnosis_id
                      images: $images
                      last_img_time: $last_img_time
                      agent_name: $agent_name
                    )
                  }`,
                  variables: {
                    diagnosis_id: this.diagnosis_id,
                    images: imgArr,
                    last_img_time: syncLastTime,
                    agent_name: agentName
                  },
                  errorPolicy: "all"
                });
                if (response.data) {
                  count++;
                  if (count === newImagesArrAll.length) {
                    /*if (val === 'sk1' || val === 'sk2') {
                      this.skLoading = false;
                    } else {
                      this[val + 'Loading'] = false;
                    }
                    this.$message({
                      message: "上传图片成功",
                      type: "success"
                    });*/
                    // const lastsynctime = new Date().getTime();
                    // window.localStorage.setItem(`lastsynctime_${type}`, lastsynctime);
                  }
                }
              }
            } catch (e) {
              console.log(e);
              this.$message.error('获取失败');
              /*if (val === 'sk1' || val === 'sk2') {
                this.skLoading = false;
              } else {
                this[val + 'Loading'] = false;
              }*/
            }
          } else {
            this.$message.error('未获取到IP地址');
          }
        } else {
          this.$message.error('未获取到IP地址');
        }
      },
      refreshImages() {
        this.$emit('refreshImages')
      },
      lineResizeEnter(e) {
        e.stopPropagation();
        this.lineEnter = true
      },
      lineResizeLeave(e) {
        e.stopPropagation();
        if (!this.lineResizeToggle) {
          this.lineEnter = false
        }
      },
      lineResizeDown(e) {
        e.stopPropagation();
        this.lineResizeToggle = true
        this.lineResizeClientX = e.clientX
      },
      imgError(event, url) {
        event.srcElement.src = url;
        
      },
      // 点击镜下所见保存按钮
      async saveTemplate(e, type) {
        e.stopPropagation();
        if (this.diagnosis_id === -1) {
          this.$message.error("请先添加检查部位!!!");
        } else {
          await this.queryMyTemplate();
          const id = this.queryMyTemplatesByName(this.diagnoseResult);
          if (id) {
            // 保存top5数据
            const data = {
              id: this.diagnoseType + '-' + id + '-0',
              name: this[type + 'UnderMirror'],
              dis: true,
            };
            this.$emit('saveTop5', {data, isSaveBtn: true});
          } else {  // 如果没有添加病名
            this.$message.error("请先添加自定义模板中的影像诊断!");
          }
        }
      },
      //
      // 选择了镜下所见备选项
      selectAutoTemplate(value, type) {
        this[type + 'UnderMirror'] = value;
        this.skAuto = false;
        this.ctAuto = false;
        this.bcAuto = false;
        this.blAuto = false;
      },
      // 显示镜下所见备选项
      autoComplete(event, val) {
        event.stopPropagation();
        if (this.template.top5Knowledge) {
          const filterArr = this.template.top5Knowledge[this.diagnoseType].filter(item => {
            return item.id === this.diseaseid;
          });
          if (filterArr.length > 0) {
            this[val + 'AutoList'] = filterArr[0].children;
            this[val + 'Auto'] = true;
          }
        }
        // 取消建议模板显示
        this.$emit('closeShowSuggestionTemplate');
      },
      closeAutoComplete() {
        this.skAuto = false;
        this.ctAuto = false;
        this.bcAuto = false;
        this.blAuto = false;
      },
      activeRadio(index, status) {
        if (index !== this.choosedResultIndex) {
          switch (index) {
            case 0:
              this.model0Active = false;
              break;
            case 1:
              this.model1Active = false;
              break;
            case 2:
              this.model2Active = false;
              break;
          }
        }

      },
      unactiveRadio(index, status) {
        if (index !== this.choosedResultIndex) {
          switch (index) {
            case 0:
              this.model0Active = true;
              break;
            case 1:
              this.model1Active = true;
              break;
            case 2:
              this.model2Active = true;
              break;
          }
        }
      },
      async modifyDiagnose(type) {
        let diagnoseId = this.diagnosis_id;
        switch (type) {
          case 10:
            let skinText1 = this.skinUnderMirror;
            let skinRes1 = await this.$apollo.mutate({
              mutation: gql`mutation ($id: Int!,$dermoscopy_report_text: String){
                            modifyDiagnosis(id: $id,dermoscopy_report_text: $dermoscopy_report_text)
                        }`,
              variables: {
                id: diagnoseId,
                dermoscopy_report_text: skinText1
              }
            })
            break;
          case Utils.GENERAL.code:
            let geText = await this.generalUnderMirror;
            let geRes = this.$apollo.mutate({
              mutation: gql`mutation ($id: Int!, $macro_report_text: String){
                            modifyDiagnosis(id: $id,macro_report_text: $macro_report_text)
                        }`,
              variables: {
                id: diagnoseId,
                macro_report_text: geText
              }
            })
            break;
          case Utils.CT.code:
            let ctText = this.ctUnderMirror;
            let ctRes = await this.$apollo.mutate({
              mutation: gql`mutation ($id: Int!,$ct_report_text: String){
                            modifyDiagnosis(id: $id,ct_report_text: $ct_report_text)
                        }`,
              variables: {
                id: diagnoseId,
                ct_report_text: ctText
              }
            })
            break;
          case Utils.BC.code:
            let bcText = this.bcUnderMirror;
            let bcRes = await this.$apollo.mutate({
              mutation: gql`mutation ($id: Int!,$b_ultrasonic_report_text: String){
                            modifyDiagnosis(id: $id,b_ultrasonic_report_text: $b_ultrasonic_report_text)
                        }`,
              variables: {
                id: diagnoseId,
                b_ultrasonic_report_text: bcText
              }
            })
            break;
          case Utils.PATHOlOGY.code:
            let blText = this.blUnderMirror;
            let blRes = await this.$apollo.mutate({
              mutation: gql`mutation ($id: Int!,$pathology_report_text: String){
                            modifyDiagnosis(id: $id,pathology_report_text: $pathology_report_text)
                        }`,
              variables: {
                id: diagnoseId,
                pathology_report_text: blText
              }
            })
            break;
        }
      },
      chooseSum(event, index) {
        switch (index) {
          case 0:
            this.model1Active = true;
            this.model2Active = true;
            this.model0Active = false;
            break;
          case 1:
            this.model0Active = true;
            this.model2Active = true;
            this.model1Active = false;
            break;
          case 2:
            this.model0Active = true;
            this.model1Active = true;
            this.model2Active = false;
            break;
        }
        this.choosedResultIndex = index;
      },
      showRemoteSkinPanel() {
        if (!this.showRemoteSkin) {
          this.showRemoteSkin = true;
        }
      },
      hideRemoteSkinPanel() {
        if (this.showRemoteSkin) {
          this.showRemoteSkin = false;
        }
      },
      showSkinPanel() {
        if (!this.showSkin) {
          this.showSkin = true;
        }
      },
      hideSkinPanel() {
        if (this.showSkin) {
          this.showSkin = false;
        }
      },
      // 选择皮肤镜类型
      showSkinType(type) {
        switch (type) {
          case "jr":
            this.skinType = Utils.SOAK.code;
            break;
          case "pz":
            this.skinType = Utils.POLARRIZE.code;
            break;
        }
        this.showSkin = false;
      },
      detectSkinArr() {
        let arr = [];
        for (let i = 0; i < this.ImgArr.length; i++) {
          if (this.ImgArr[i].type === Utils.SOAK.code || this.ImgArr[i].type === Utils.POLARRIZE.code) {
            arr.push(this.ImgArr[i]);
          }
        }
        return arr;
      },
      detectImgArr(params) {
        let arr = [];
        for (let i = 0; i < this.ImgArr.length; i++) {
          if (this.ImgArr[i].type === params) {
            arr.push(this.ImgArr[i]);
          }
        }
        return arr;
      },
      // 选择对应的病种
      chooseTheRadio(event, item, index) {
        switch (index) {
          case 0:
            // console.log("model0 is ", this.model0);
            break;
          case 1:
            // console.log("model0 is ", this.model1);
            break;
          case 2:
            // console.log("model0 is ", this.model2);
            break;
        }
        this.overviewRadio = event;
        this.choosedResultIndex = index;
      },
      // 防止插入重复的值
      checkArrIsRepeat(imgArr, imgItem) {
        for (let i = 0, len = imgArr.length; i < len; i++) {
          if (imgArr[i].type === imgItem.type && imgArr[i].id === imgItem.id) {
            return false;
          }
        }
        return true;
      },
      // 对图片进行操作
      opration(data) {
        switch (data.type) {
          case "delete":
            this.$emit("message", {delete: true, type: "deleteImg", id: data.id});
            break;
          case "editor":
            this.$emit("message", {
              editor: true,
              type: "imgEditor",
              imgSrc: data.imgSrc,
              id: data.id,
              idType: data.idType,
              index: data.index,
              position:data.position

            });
            break;
        }
      },
      // 显示删除按钮
      showRemove(index, isShow) {
        if (this.general) {
          for (let i = 0, len = this.generalReportImgs.length; i < len; i++) {
            if (index === i) {
              this.generalReportImgs[i].showDelete = isShow;
            }
          }
        } else if (this.ct) {
          for (let i = 0, len = this.ctReportImgs.length; i < len; i++) {
            if (index === i) {
              this.ctReportImgs[i].showDelete = isShow;
            }
          }
        } else if (this.bc) {
          for (let i = 0, len = this.bcReportImgs.length; i < len; i++) {
            if (index === i) {
              this.bcReportImgs[i].showDelete = isShow;
            }
          }
        } else if (this.sk) {
          for (let i = 0, len = this.skinReportImgs.length; i < len; i++) {
            if (index === i) {
              this.skinReportImgs[i].showDelete = isShow;
            }
          }
        } else if (this.bingli) {
          for (let i = 0, len = this.blReportImgs.length; i < len; i++) {
            if (index === i) {
              this.blReportImgs[i].showDelete = isShow;
            }
          }
        }
      },
      // 从拖拽报告中的图片删除
      deteImgFromReport(index) {
        if (this.general) {
          this.generalReportImgs.splice(index, 1);
          this.$store.commit("handleReportByType", {opration: "delete", index, data: "", type: 'general'});
        } else if (this.ct) {
          this.ctReportImgs.splice(index, 1);
          this.$store.commit("handleReportByType", {opration: "delete", index, data: "", type: 'ct'});
        } else if (this.bc) {
          this.bcReportImgs.splice(index, 1);
          this.$store.commit("handleReportByType", {opration: "delete", index, data: "", type: 'bc'});
        } else if (this.sk) {
          this.skinReportImgs.splice(index, 1);
          this.$store.commit("handleReportByType", {opration: "delete", index, data: "", type: 'skin'});
        } else if (this.bingli) {
          this.blReportImgs.splice(index, 1);
          this.$store.commit("handleReportByType", {opration: "delete", index, data: "", type: 'bl'});
        }
      },
      intelligentSearch() {
        // 清空之前的预览结果
        // this.skinReportImgs = [];
        // this.$store.state.skinReportImgs = [];
        // this.skinUnderMirror = "";
        this.tempJsonArray = [];
        // 通知父组件显示智能搜图弹框
        let intellChooseImgs = this.$store.state.chooseItImgArr;
        this.reviewImgArr = _.cloneDeep(intellChooseImgs);
        this.$emit("message", {searchPic: true, type: "intelligentSearch"});
      },
      takeAPhone(type) {
        if (this.diagnosis_id === -1) {
          this.$message.error("请先添加检查部位!!!");
          return;
        }
        this.$emit("message", {takeAPhone: true, type: 'takePhone', picType: type});
      },
      // 上传完成之前显示缩略图
      handleShowThumbnailImage(imgObjArr) {
        this.$emit('showThumbnailImage', imgObjArr);
      },

      async upload(event, type) {
        let e = window.event || event;
        // 如果没有选中文件就return
        if (!e.target.files.length) {
          e.target.value = '';
          return;
        }
        switch (type) {
          case "jr":
            // console.log("上传浸润皮肤镜图片");
            this.skinType = Utils.SOAK.code;
            this.skLoading = true;
            break;
          case "pz":
            // console.log("上传偏振光皮肤镜图片");
            this.skinType = Utils.POLARRIZE.code;
            this.skLoading = true;
            break;
          case 'general':
            this.generalLoading = true;
            break;
          case 'ct':
            this.ctLoading = true;
            break;
          case 'bc':
            this.bcLoading = true;
            break;
          case 'bl':
            this.bingliLoading = true;
            break;
        }
        if (this.diagnosis_id === -1) {
          this.$message.error("请先添加检查部位!!!");
          this.setLoadingStatus(type, false);
          e.target.value = '';
          return;
        }
        if (!this.position) {
          this.$message.error("请先添加检查部位");
          this.setLoadingStatus(type, false);
          e.target.value = '';
          return;
        }
        let imgObjArr = [];
        let thumbnailIimages = [];
        await this.dealImgFile(e.target.files, imgObjArr, thumbnailIimages, type);
        let params = {
          diagnosis_id: this.diagnosis_id,
          images: imgObjArr,
          thumbnailIimages
        }
        if (!!params.diagnosis_id && !!params.images) {
          // 先显示缩略图
          this.handleShowThumbnailImage(params.images);
          // 上传
          const imagesArr = _.chunk(params.images, 1);
          const thumbnailImagesArr = _.chunk(params.thumbnailIimages, 1);
          let count = 0;
          for (const images of imagesArr) {
            try {
              let uploadImgsResponse = await this.$apollo.mutate({
                // Query
                mutation: gql`mutation ($diagnosis_id: Int!,$images: [ImageInput!]!, ,$thumbnail_images: [ThumbnailImageInput!]!){
                                addImagesFaster(diagnosis_id: $diagnosis_id,
                                    images: $images, thumbnail_images: $thumbnail_images),
                            }`,
                variables: {
                  diagnosis_id: params.diagnosis_id,
                  images,
                  thumbnail_images: thumbnailImagesArr[count],
                }
              });
              count++;
              if (count === imagesArr.length) {
                 this.setLoadingStatus(type, false);
                this.$message({
                  message: "上传图片成功",
                  type: "success"
                });
              }
            } catch (e) {
              this.setLoadingStatus(type, false);
              this.$message("上传失败");
              console.log(e)
              //this.$message.error(e);
            }
          }
        
        } else {
          this.setLoadingStatus(type, false);
          this.$message.error("参数错误!");
        }
        e.target.value = '';
      },
      setAllLoadingStatus(status){
        this.skLoading = status;
        this.skLoading = status;
        this.generalLoading = status;
        this.ctLoading = status;
        this.bcLoading = status;
        this.bingliLoading = status;
      },
      setLoadingStatus(type, status) {
        switch (type) {
          case "jr":
            this.skLoading = status;
            break;
          case "pz":
            this.skLoading = status;
            break;
          case 'general':
            this.generalLoading = status;
            break;
          case 'ct':
            this.ctLoading = status;
            break;
          case 'bc':
            this.bcLoading = status;
            break;
          case 'bl':
            this.bingliLoading = status;
            break;
        }
      },
      async dealImgFile(filesList, imgObjArr, thumbnailIimages, type) {
        try {
          let self = this;
          let len = filesList.length;
          let type = Utils.SOAK.code;
          if (this.general) {
            type = Utils.GENERAL.code;
          } else if (this.ct) {
            type = Utils.CT.code;
          } else if (this.bc) {
            type = Utils.BC.code;
          } else if (this.sk) {
            if (this.skinType !== -1) {
              type = this.skinType;
            } else {
              this.$message.error("请先选择皮肤镜类型");
              return;
            }
          } else if (this.bingli) {
            type = Utils.PATHOlOGY.code;
          }
          for (let i = 0; i < len; i++) {
            // 得到文件的扩展名
            let ext = Path.extname(filesList[i].name).substring(1);
            let imgsObj = {
              type,
              ext,
            }
            //console.log(imgsObj);

            if (ext === 'bmp' || ext === 'dib'|| ext === 'BMP') {
              // 转换成jpeg图片
              let reader = new FileReader();
              await new Promise((resolve, reject) => {
                reader.readAsDataURL(filesList[i]);
                reader.onload = async (event) => {
                  let b6 = await self.dealBmpImage(event.target.result);
                  //console.log(event.target.result);

                  imgsObj.base64 = b6.replace(/^data:image\/(jpeg|png);base64,/, "");
                  imgsObj.position_overview = self.position.overviewPosition;
                  imgsObj.position_detail = self.position.overviewPosition + '-' + self.position.detailPosition;
                  imgsObj.ext = 'jpg';
                  imgsObj.upload_mark = new Date().valueOf() + '_' + Math.floor(Math.random() * 1000);
                  imgObjArr.push(imgsObj);

                  //this.compressImg(b6.replace(/^data:image\/(jpeg|png);base64,/, ""), (a, base64) => {
                  this.compressImg(b6, (a, base64) => {
                    thumbnailIimages.push({
                      base64: base64.replace(/^data:image\/(jpeg|png);base64,/, "")
                    })
                    resolve()
                  })
                }
              });

            } else {
              if (ext === 'pjpeg' || ext === 'jfif' || ext === 'pjp' || ext === 'jpeg'||  ext === 'jpe'|| ext === 'JPG'|| ext === 'JPEG') {
                ext = 'jpg';
              }
              if (ext === 'PNG') {
                ext = 'png';
              }
              let reader = new FileReader();
              await new Promise((resolve, reject) => {
                reader.readAsDataURL(filesList[i]);
                reader.onload = (event) => {
                  imgsObj.base64 = event.target.result.replace(/^data:image\/(jpeg|png);base64,/, "");
                  imgsObj.position_overview = self.position.overviewPosition;
                  imgsObj.position_detail = self.position.overviewPosition + '-' + self.position.detailPosition;
                  imgsObj.ext = ext;
                  imgsObj.upload_mark = new Date().valueOf() + '_' + Math.floor(Math.random() * 1000);
                  imgObjArr.push(imgsObj);

                  this.compressImg(event.target.result, (a, base64) => {
                    thumbnailIimages.push({
                      base64: base64.replace(/^data:image\/(jpeg|png);base64,/, "")
                    })
                    resolve()
                  })
                }
              });
            }
          }
        } catch (e) {
          this.setLoadingStatus(type, false);
        }
      },
      // 生成缩略图
       async compressImg (base64str, callback) {
        // 处理缩放，转换格式
        // new 一个图片，用canvas来压缩
        const img = new Image();
        img.src = base64str;

        let base64 = '';
        await new Promise((resolve, reject) => {
          img.onload = function () {
            const canvas = document.createElement('canvas')
            const ctx = canvas.getContext('2d');
            let iScale = Math.floor(this.width / 200);
            canvas.setAttribute('width', 200)
            canvas.setAttribute('height', Math.floor(this.width/iScale));
            ctx.clearRect(0, 0, canvas.width, canvas.height)
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
            // 转成base64 文件
            base64 = canvas.toDataURL('image/jpeg')
            // 根据自己需求填写大小
           while (base64.length > 1024 * 1024 * 6) {
              scale -= 0.01
              base64 = canvas.toDataURL('image/jpeg', iScale)
            }
            const arr = base64.split(',')
            const mime = arr[0].match(/:(.*?);/)[1]
            const bytes = atob(arr[1])
            const bytesLength = bytes.length
            const u8arr = new Uint8Array(bytesLength)
            for (let i = 0; i < bytes.length; i++) {
              u8arr[i] = bytes.charCodeAt(i)
            }
            const blob = new Blob([u8arr], { type: mime })
            // 回调函数 根据需求返回二进制数据或者base64数据，我的项目都给返回了
            callback(blob, base64);
            resolve();
          }
        })
      },



      async dealBmpImage(filePath) {
          //console.log("in dealBmpImage, filePath:",filePath);
          //console.log(filePath);
          const image = await Jimp.read(filePath);
          // image.quality(95);
          const base64 = await image.getBase64Async(Jimp.MIME_JPEG);
          return base64;
        
      },
      async dealBmpImage1(filePath) {
        try {
          let base64;
          await new Promise((resolve, reject) => {
            function getBase64(imgUrl) {
              window.URL = window.URL || window.webkitURL;
              let xhr = new XMLHttpRequest();
              xhr.open("get", imgUrl, true);
              // 至关重要
              xhr.responseType = "blob";
              xhr.onload = function() {
                if (this.status === 200) {
                  // 得到一个blob对象
                  let blob = this.response;
                  // 至关重要
                  let oFileReader = new FileReader();
                  oFileReader.onloadend = (e) => {
                    base64 = e.target.result;
                    resolve();
                  };
                  oFileReader.readAsDataURL(blob);
                } else {
                  reject();
                }
              };
              xhr.send();
            }
            getBase64(filePath)
          });
          return base64;
        } catch (e) {
          await this.dealBmpImage1(filePath)
        }
    
      },
      remotePull(val) {
        if (val === 'ct') {
          // console.log("远程获取 ct");
          this.remotePullPackaging('CT', 8, val);
        } else if (val === 'bc') {
          // console.log("远程获取 bc");
          this.remotePullPackaging('B_ultrasonic', 16, val);
        } else if (val === 'bingli') {
          // console.log("远程获取 bingli");
          this.remotePullPackaging('pathology', 32, val);
        } else if (val === 'sk1') {
          // console.log("远程获取 sk1");
          this.remotePullPackaging('sk', 2, val);
        } else if (val === 'sk2') {
          // console.log("远程获取 sk2");
          this.remotePullPackaging('sk', 4, val);
        }
      },
      async remotePullPackaging(type, typeIndex, val) {
        try {
          const system_set = JSON.parse(localStorage.system_set);
          if (system_set[type].ip && system_set[type].port) {
            if (this.diagnosis_id === -1) {
              this.$message.error("请先添加检查部位!!!");
              return;
            }
            try {
              // 获取http地址
              const url = `https://${system_set[type].ip}:${system_set[type].port}`;
              // 请求key并算出secret
              const msgKey = await axios.get(url + '/key');
              const secret = crypto.createHash('sha1').update(msgKey.data.key.split('').reverse().join('')).digest('hex');
              this.$store.commit('secret', secret);
              this.requestUrl = url + '/list?secret=' + secret;
              this.url = url;
              this.secretPath = `?secret=${secret}`;

              // 请求list获取图片地址列表
              const msgList = await axios.request({
                method: 'get',
                url: this.requestUrl,
              });
              // 生成文件夹数据
              const folders = msgList.data.folders;
              let folderData = [];
              for (let i = 0; i < folders.length; i++) {
                // const res = await axios.request({
                //   method: 'get',
                //   url: `${this.requestUrl}&path=${folders[i]}`,
                // });
                // if (res.data.folders.length > 0) {
                  folderData.push({
                    label: decodeURIComponent(folders[i]),
                    children: [
                      {}
                    ],
                    path: `${folders[i]}`,
                    bool: true,
                  });
                // } else {
                //   folderData.push({
                //     label: decodeURIComponent(folders[i]),
                //     children: [],
                //     path: `${folders[i]}`,
                //     bool: true,
                //   });
                // }
              }
              this.folderData = folderData;
              // 生成图片数据
              const images = msgList.data.images;
              let imagesData = [];
              for (let i = 0; i < images.length; i++) {
                imagesData.push({
                  id: ++this.imageId,
                  url: `${url}/${images[i].file}?secret=${secret}`,
                  isSelect: false,
                  name: decodeURIComponent(images[i].file),
                  origin: images[i].origin,
                })
              }
              this.remoteImages = imagesData;
              // 保存根目录图片数据
              this.remoteImagesBackups = imagesData;
              // dialog弹框显示
              this.dialogVisible = true;
              this.loadingType[val].isClick = true;
            } catch (e) {
              this.$message.error('获取失败');
            }
          } else {
            this.$message('未获取到IP地址');
          }
        } catch (err) {
          this.$message.error('未获取到IP地址');
        }
      },
      // 图片加载完成
      imageOnload(e) {
        const tag = e.target;
        if (tag.width / tag.height >= 1) {
          e.srcElement.style.width = '150px';
          e.srcElement.style.height = 'auto';
        } else {
          e.srcElement.style.height = '150px';
          e.srcElement.style.width = 'auto';
        }
      },
      // 远程获取弹窗
      openRemoteDialog(val) {
        this.remotePull(val);
      },
      // 远程获取图片是否选中
      imageSelect(index) {
        this.remoteImages[index].isSelect = !this.remoteImages[index].isSelect;
      },
      // 选择文件夹
      async handleNodeClick(data) {
        if (this.abc === 1) {
          return
        }
        this.abc = 1;
        this.highlightCurrent = true;
        try {
          const response = await axios.request({
            method: 'get',
            url: `${this.requestUrl}&path=${data.path}`
          });
          if (data.bool) {
            // 生成文件夹数据
            const folders = response.data.folders;
            let folderData = [];
            for (let i = 0; i < folders.length; i++) {
              // const res = await axios.request({
              //   method: 'get',
              //   url: `${this.requestUrl}&path=${data.path}/${folders[i]}`
              // });
              // if (res.data.folders.length > 0) {
              folderData.push({
                label: decodeURIComponent(folders[i]),
                children: [
                  {}
                ],
                path: `${data.path}/${folders[i]}`,
                bool: true,
              });
              // } else {
              //   folderData.push({
              //     label: decodeURIComponent(folders[i]),
              //     children: [],
              //     path: `${data.path}/${folders[i]}`,
              //     bool: true,
              //   });
              // }
            }
            data.children = folderData;
            data.bool = false;
          }
          // 生成图片数据
          const images = response.data.images;
          let imagesData = [];
          for (let i = 0; i < images.length; i++) {
            imagesData.push({
              id: ++this.imageId,
              url: `${this.url}/${data.path}/${images[i].file}${this.secretPath}`,
              isSelect: false,
              name: decodeURIComponent(images[i].file),
              origin: images[i].origin,
            })
          }
          this.remoteImages = imagesData;
        } catch (e) {
          this.$message.error('获取失败');
        }
        this.abc = 0;
      },
      // 回到文件夹根目录
      backToRoot() {
        this.remoteImages = this.remoteImagesBackups;
        this.highlightCurrent = false;
      },
      // 获取远程图片
      async remoteAccess() {
        
        let valClone;
        try {
          const load = this.loadingType;
          const val = await new Promise(resolve => {
            for (let key in load) {
              if (load[key].isClick === true) {
                resolve(key)
              }
            }
          });
          valClone = val;
          if (val === 'sk1' || val === 'sk2') {
            this.skLoading = true;
          } else {
            this[val + 'Loading'] = true;
          }
          this.loadingType[val].isClick = false;
          this.dialogVisible = false;
          const remoteImages = this.remoteImages;
          const imagesArrAll = remoteImages.filter(item => item.isSelect === true);
          const newImagesArrAll = _.chunk(imagesArrAll, 2);
          let count = 0;
          for (const imagesArr of newImagesArrAll) {
            // 上传前处理
            let imgArr = [];
            for (let i = 0; i < imagesArr.length; i++) {
              const item = imagesArr[i];
              let ext = 'jpg';
              const postfix = item.name.split('.')[1];
              if (postfix === 'jpg' || postfix === 'jpeg' || postfix === 'png') {
                ext = postfix;
              }
              const b64 = await this.dealBmpImage(item.url);
              const obj = {
                type: this.loadingType[val].typeIndex,
                position_overview: this.position.overviewPosition,
                position_detail: this.position.overviewPosition + '-' +this.position.detailPosition,
                base64: b64.replace(/^data:image\/(jpeg|png);base64,/, ""),
                ext,
                origin: imagesArr[i].origin,
              };
              imgArr.push(obj);
            }
            if (imgArr.length === 0) {
              this.$message('没有选择图片');
              if (val === 'sk1' || val === 'sk2') {
                this.skLoading = false;
              } else {
                this[val + 'Loading'] = false;
              }
              return;
            }
            // 上传
            const response = await this.$apollo.mutate({
              mutation: gql`mutation ($diagnosis_id: Int!,$images: [ImageInput!]!,$sync_time: String){
                                    addImages(diagnosis_id: $diagnosis_id,
                                        images: $images,sync_time: $sync_time),
                                }`,
              variables: {
                diagnosis_id: this.diagnosis_id,
                images: imgArr,
                sync_time: String(new Date().valueOf()),
              },
              errorPolicy: "all"
            });
            if (response.data) {
              count++;
              if (count === newImagesArrAll.length) {
                if (val === 'sk1' || val === 'sk2') {
                  this.skLoading = false;
                } else {
                  this[val + 'Loading'] = false;
                }
                this.$message({
                  message: "上传图片成功",
                  type: "success"
                });
              }
            }
          }
        } catch (e) {
          this.setLoadingStatus(type, false);
          if (valClone === 'sk1' || valClone === 'sk2') {
            this.skLoading = false;
          } else {
            this[valClone + 'Loading'] = false;
          }
        }
      },
      //
      closeDialog() {
        this.dialogVisible = false;
        const load = this.loadingType;
        for (let key in load) {
          if (load.hasOwnProperty(key)) {
            load[key].isClick = false;
          }
        }
      },
      detailResult() {
        // 控制详细结果的显隐
        this.$emit("message", {detailResult: true, type: "detailResult"});
      },
      // 导入报告
      async importReport() {
        // this.skinReportImgs = [];
        // this.$store.state.skinReportImgs = [];
        if (this.overviewResult.length === 0) {
          this.$message.error(`请先点击${this.differentContent.buttonCon}!!`);
          return;
        }
        // diagnosis_id
        // 对应病的编号
        // let diseaseObj = this.wordBook[`${this.overviewRadio}`];
        let diseaseObj = {
          name: this.overviewRadio,
        };
        diseaseObj.code = this.overviewRadio;
        // 找出对应病的描述
        // 对应病的图片
        let diseaseImg = this.tempJsonArray[this.choosedResultIndex].src;

        let id = this.tempJsonArray[this.choosedResultIndex].id;
        let imgObj = {
          src: diseaseImg,
          showDelete: false,
          position: this.position,
          index: this.choosedResultIndex,
          id
        }
        imgObj.type = "皮肤镜"
        await this.adapteImg(imgObj);
        // 通知仓库push这些数据
        // this.$store.commit("handleReportByType", {opration: "add", index: -1, data: imgObj, type: "skin"});
        // this.skinReportImgs.push(imgObj);
        this.$emit("message", {
          type: "importReport",
          data: diseaseObj,
          reportImgs: this.skinReportImgs,
          position: this.position,
          mode: "skin"
        });
        // 向父组件传事件
        this.$emit('saveConclusion');
      },
      // 处理图片自适应
      adapteImg(imgObj) {
        return new Promise((resolve, reject) => {
          let img = new Image();
          img.src = imgObj.src;
          img.onload = () => {
            let imgWidth = img.width;
            let imgHeight = img.height;
            if (imgWidth / imgHeight > 80 / 42) {
              img.width = 80;
              img.height = imgHeight * 80 / imgWidth;
            } else {
              img.height = 42;
              img.width = imgWidth * 42 / imgHeight;
            }
            imgObj.width = img.width;
            imgObj.height = img.height;
            resolve();
          }
        })
      },
      async dbclickAdd(event, item) {
        let imgSrc = event.target.src;
        // console.log("图片的路径是：", imgSrc);
        // console.log("图片的部位是：", this.position);
        //   console.log('item',item)
        //   console.log('event2',event)
        let newPosition = {
          active: true,
          detailPosition:item.position_detail? item.position_detail.split('-')[1]:"",
          overviewPosition: item.position_detail? item.position_detail.split('-')[0]:"",
        }
        // console.log('newPosition',newPosition)
        let imgObj = {
          src: imgSrc,
          showDelete: false,
          position: newPosition,
          index: 0,
          id: item.id,
          type1: item.type
        }
        await this.adapteImg(imgObj);
        this.dealReportImgs(imgObj);
      },
      async drop(event) {
        event.preventDefault();
        let data = event.dataTransfer.getData('Text');
        let id;
        for (let i = 0; i < this.ImgArr.length; i++) {
          if (this.ImgArr[i].path === data.split("?")[0]) {
            id = this.ImgArr[i].id;
          }
        }
        let imgObj = {
          src: data,
          showDelete: false,
          position: this.position,
          index: 0,
          id
        }
        await this.adapteImg(imgObj);
        this.dealReportImgs(imgObj);
        // this.reportImgs.push(imgObj);
      },
      dealReportImgs(imgObj) {
        if (imgObj.type1 === 1) {
          imgObj.type = "大体图/伍德灯"
          this.generalReportImgs.push(imgObj);
          // 将其同步到vuex中
          this.$store.commit("handleReportByType", {opration: "add", index: -1, data: imgObj, type: 'general'});
        } else if (imgObj.type1 === 8) {
          imgObj.type = "CT"
          this.ctReportImgs.push(imgObj);
          this.$store.commit("handleReportByType", {opration: "add", index: -1, data: imgObj, type: 'ct'});
        } else if (imgObj.type1 === 16) {
          imgObj.type = "B超"
          this.bcReportImgs.push(imgObj);
          this.$store.commit("handleReportByType", {opration: "add", index: -1, data: imgObj, type: 'bc'});
        } else if (imgObj.type1 === 2 || imgObj.type1 === 4) {
          imgObj.type = "皮肤镜"
          this.skinReportImgs.push(imgObj);
          this.$store.commit("handleReportByType", {opration: "add", index: -1, data: imgObj, type: 'skin'});
        } else if (imgObj.type1 === 32) {
          imgObj.type = "病理"
          this.blReportImgs.push(imgObj);
          this.$store.commit("handleReportByType", {opration: "add", index: -1, data: imgObj, type: 'bl'});
        }
      },
      allowDrop(event) {
        event.preventDefault();
      },
      uploadFile(val) {
        this.$refs[val].dispatchEvent(new MouseEvent('click'));
      },
      handleAllSelect(bool) {
        this.allSelect = bool;
        if (bool) {
          const arr = this.remoteImages;
          arr.forEach(item => {
            item.isSelect = true;
          })
        } else {
          const arr = this.remoteImages;
          arr.forEach(item => {
            item.isSelect = false;
          })
        }
      },
    },
  }
</script>
<style lang="less" scoped>
  .page-con {
    width: 100%;
    height: 100%;
  }

  .bottom-wrapper,
  .head-con,
  .head-nav,
  .summary,
  .img-list-con,
  .img-list,
  .row-con,
  .img-item,
  .rightRadio,
  .line-sesu,
  .right-img-con,
  .CTetc-con,
  .top-nav,
  .left-row,
  .right-row,
  .img-con,
  .report-con,
  .btns,
  .imgCon,
  .img-box,
  .upload-con,
  .btn-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
  }

  textarea::-webkit-input-placeholder {
    color: #61a2bf;
    font-size: 16px;
    font-weight: normal;
  }

  /*::-webkit-scrollbar {*/
    /*width: 5px;*/
    /*height: 100%;*/
  /*}*/
  
  /*::-webkit-scrollbar-track-piece {*/
    /*background: #fff;*/
    /*-webkit-border-radius: 6px;*/
  /*}*/
  
  /*::-webkit-scrollbar-thumb:vertical {*/
    /*background-color: #61a2bf;*/
    /*-webkit-border-radius: 6px;*/
  /*}*/

  // @media screen and (min-width: 1366px){
  //     .page-con{
  //         .bottom-wrapper{
  //             .head-con{
  //                 .img-con{
  //                     height:130px;
  //                 }
  //             }
  //             .summary{
  //                 height: 85px;
  //                 .img-list-con{
  //                     .btns{
  //                         margin-top: -20px;
  //                     }
  //                 }
  //             }
  //             .report-con{
  //                 .left-row{
  //                     height: 90px;
  //                 }
  //                 .right-row{
  //                     height: 90px;
  //                 }
  //             }
  //         }
  //     }

  // }
  .uploadBtn {
    color: #fff;
    font-size: 13px;
    position: relative;
    border-radius: 4px;

    .uploadType {
      background: #fff;
      white-space: nowrap;
      color: #000;
      position: absolute;
      bottom: -90px;
      font-size: 15px;
      padding: 10px 0px;
      border-radius: 4px;
      right: 15px;
      z-index: 200;

      .skinType {
        border-bottom: 1px solid #61a2bf;
        padding: 10px 5px;
        cursor: pointer;

        .skinItem {
          position: relative;
          text-align: left;

          .upload_input {
            position: absolute;
            top: 0px;
            left: 0px;
            cursor: pointer;
          }

        }
      }

      .skinType:nth-child(2) {
        border-bottom: 0px solid #fff;
      }
    }
  }

  .customBtn {
    padding: 8px 10px;
    color: #fff;
    background: #61a2bf;
    border-radius: 5px;
    min-width: 80px;
    cursor: pointer;

  }

  .el-dropdown {
    vertical-align: top;
  }

  .animation(@animation-name,@animation-duration,@animation-timing-function,@animation-delay) {
    animation: @arguments;
    -moz-animation: @arguments;
    -webkit-animation: @arguments;
    -o-animation: @arguments;

  }

  @keyframes loading {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .loadingWait {
    animation: loading 1.5s linear infinite;
    width: 24px;
    height: auto;
  }

  .bottom-wrapper {
    flex-direction: column;
    color: #61a2bf;
    height: 97%;
    padding-top: 5px;
    position: relative;
    padding-bottom: 6px;
    .refresh-images-btn{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      padding: 0;
      margin-right: 10px;
      color: #fff;
      font-size: 19px;
    }

    .head-con {
      flex-direction: column;
      width: 100%;
      height: 55%;

      .head-nav {
        justify-content: space-between;
        width: 98%;
        padding: 0.5 0.1%;

        .text {
          padding-left: 1%;
          white-space: nowrap;
          font-size: 16px;
        }

        .btn-wrapper {
          padding-right: 1%;

          .upload-con {
            position: relative;
            justify-content: center;
            position: relative;

            .upload_input {
              display: none;
              cursor: pointer;
              position: absolute;
              top: 0px;
              left: 0px;
              width: 80px;
              height: 30px;
              opacity: 0;
            }
          }
        }
      }

      .img-con {
        width: 100%;
        // min-height: 180px;
        height: 88%;
        overflow-y: auto;
        overflow-x: hidden;
        align-items: flex-start;
        flex-wrap: wrap;
        margin-top: 5px;

        .generalWrapper {
          margin-left: 1%;
        }

        .loading {
          width: 80px;
          height: 40px;
          background-color: rgba(61, 158, 255, .7);
        }
      }
    }

    .summary {
      position: relative;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      height: 100%;
      width: 49.5%;
      margin-left: 0.5%;
      box-sizing: border-box;
      border-radius: 10px;
      border: 1px solid #48a3c2;

      .sum-head {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-top: 0.5%;
        margin-bottom: 1%;
        padding-left: 5px;
        box-sizing: border-box;
        .btn-btn{
          width: 100px;
        }
      }

      .img-list-con {
        width: 100%;
        flex: 1;
        justify-content: space-between;
        padding: 5px;
        box-sizing: border-box;

        .img-list {
          width: 100%;

          .img-item {
            width: 49%;
            height: 94px;
            margin-right: 2%;
            overflow: hidden;

            .radioCon {
              display: flex;
              flex-direction: column;

            }

            .rightRadio {
              flex-direction: column;
              justify-content: center;
              align-items: center;
              margin-left: 12%;

              .line-sesu {
                margin-left: 4%;
              }
            }
          }

          // .img-item:nth-child(1) {
          // }

          .img-item:nth-child(2) {
            margin-right: 0;
          }
        }

        .btns {
          flex: 1;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          position: absolute;
          right: 0px;
          top: 10%;
        }
      }
    }

    .report-con {
      bottom: 2%;
      width: 98%;
      height: 30%;
      min-height: 170px;
      justify-content: space-between;
      margin-top: 5px;
      margin-left: 1%;
      margin-right: 1%;

      .left-row {
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        border: 1px solid #48a3c2;
        border-radius: 10px;
        width: 50%;
        margin-right: 2%;
        height: 100%;
        align-items: flex-start;
        margin-left: 1%;

        .text-header {
          margin-top: 5px;
          margin-left: 5px;
        }

        .imgCon {
          justify-content: flex-start;
          flex-wrap: wrap;
          flex-direction: row;

          .img-box {
            position: relative;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            width: 85px;
            height: 45px;
            margin-top: 5px;
            margin-right: 10px;
            border: 0px solid black;

            .deleIcon {
              cursor: pointer;
              position: absolute;
              right: -9px;
              top: -9px;
            }
          }

          .img-box:nth-of-type(1) {
            margin-left: 6px;
          }
        }

        .imgCon:nth-of-type(1) {
          margin-left: 10px;
        }
      }

      .right-row {
        position: relative;
        width: 100%;
        height: 100%;
        align-items: flex-start;

        .autoComplate {
          position: absolute;
          left: 0;
          top: 104%;
          width: 98%;
          background-color: #eff3f7;
          padding: 5px;
          border: 1px solid #48a3c2;
          border-radius: 10px;
          z-index: 2;

          .item {
            color: #111;
            text-align: left;
            padding: 5px 0;
            cursor: default;
            font-size: 14px;
          }

          .item + .item {
            border-top: 1px solid #eee;
          }

          .item:hover {
            background-color: #eee;
          }
        }

        .skinClass {
          .el-textarea__inner {
            background: #efeeee;
          }
        }

        .underMirrorStyle {
          background-color: #eff3f7;
          border-radius: 10px;
          resize: none;
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          border: 1px solid #48a3c2;
          font-size: 16px;

          .title-box {
            user-select: none;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 5px;
            margin-left: 5px;

            .save-btn {
              position: absolute;
              top: 2px;
              right: 4px;
              font-size: 28px;
              user-select: none;
              cursor: pointer;
            }
          }

          textarea {
            width: 98%;
            height: 78%;
            background-color: inherit;
            border: none;
            margin-top: 5px;
            font-size: 17px;
            letter-spacing: 1px;
            line-height: 20px;
          }
        }
      }
      .right-row.skin{
        width: 49.5%;
        margin-right: 0.5%;
      }
    }
  }

  .remoteWrapper {
    user-select: none;
    .line-resize{
      width: 4px;
      min-width: 4px;
      height: 100%;
      background-color: #333;
      cursor: e-resize;
    }
    .main-wrapper {
      padding: 10px;
      user-select: none;
      .main-wrapper-box{
        min-width: 930px;
        user-select: none;
      }
      .main-wrapper-box::after{
        content: '';
        display: block;
        clear: both;
      }

      .head {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 20px;
        padding-right: 30px;
        user-select: none;

        .allSelect {
          display: flex;
          align-items: center;
          user-select: none;

          .iconfont {
            margin-left: 5px;
            cursor: pointer;
            user-select: none;
            font-size: 26px;
          }
        }
      }

      .imageItem {
        position: relative;
        float: left;
        width: 150px;
        padding: 0 18px;
        margin-bottom: 20px;
        user-select: none;

        .pic {
          display: flex;
          justify-content: center;
          align-items: flex-end;
          width: 150px;
          height: 150px;
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center bottom;
          user-select: none;
        }

        .name {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          height: 44px;
          margin-top: 10px;
          text-align: center;
          word-wrap: break-word;
          user-select: none;
        }

        .isSelect {
          display: none;
          position: absolute;
          left: 18px;
          top: 0;
          width: 150px;
          height: 204px;
          color: #fff;
          background-color: rgba(0, 0, 0, .5);
          line-height: 204px;
          font-size: 80px;
          user-select: none;
        }

        .isSelect.select {
          display: block;
        }
      }

      .empty {
        margin-top: 20px;
      }
    }
  }

  .isWidth {
    width: 94px;
    height: auto;
  }

  .isHeight {
    height: 94px;
    width: auto;
  }
</style>
<style lang="less">
  
  .radio-label-text .el-radio__label{
    font-size: 16px;
  }
  
  .span-ellipsis {
    text-align: left;
  }
  .remoteWrapper{
    .el-tree{
      width: fit-content;
      /*.el-tree-node__content{*/
        /*display: block !important;*/
        /*text-align: left;*/
        /*user-select: none;*/
      /*}*/
      /*.el-tree-node__children{*/
        /*overflow: visible !important;*/
        /*text-align: left;*/
        /*user-select: none;*/
      /*}*/
    }
  }
</style>


